import { TemplateData, TemplateParams } from '.';

const courseDeadlineApproaching = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.courseDeadlineApproaching} {{expirationDate}}.
        ${messages.pathCourseDeadlineAccess}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.profileTimelineCourseDeadline}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseUrl: {
      label: messages.commonCourseLink,
      example: `${serverConfig.adminUrl}/courses/test-course`
    },
    expirationDate: {
      label: messages.commonExpirationDate,
      example: '27.3.2024'
    },
    expirationTimeInDays: {
      label: messages.siteSettingsAccountExpirationTimeInDays,
      example: '3'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCourseDeadlineApproaching
});

export default courseDeadlineApproaching;
